import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

function DetasadCloudManager(props) {
    const heading = "DETASAD CLOUD MANAGER (DCM)";
    const details = "A centralized portal to let you manage your resources in DETASAD Cloud.";

    const overview = [
        "Managed a complex, hybrid IT environment can require multiple management tools, redundant policy implementation, and extra staff to handle operations. DETASAD manager simplifies IT, providing unified management and operations in a Hybrid environment.",
        "As your IT infrastructure progresses from traditional virtualization toward an Infrastructure-as-a-Service (IaaS) model, CloudForms evolves, protecting your investments and providing consistent user experience and functionality.",
        "DETASAD Manager streamlines and automates complex management tasks across the complete cloud lifecycle. On-premises administrators can monitor and manage public cloud services, and vice versa.",
        "DETASAD services are managed by the same Hybrid DETASAD tools that customers use on-premises to monitor, provision, and maintain VMware, Hyper-V and other Public Cloud services. This additionally eliminates the costly consequences of purchasing and learning numerous new tools to manage enterprise hybrid clouds."
    ];

    const features = [
        [
            "Flexible Hierarchies & Multitenancy",
            "Exert control and clear structures in your cloud environment by creating separate organizations, defining relationships between users, tenants, and projects, and managing quotas and services. Learn more.",
            icon
        ],
        [
            "Compliance & Policies",
            "Define the policy state for your environment -- and follow up with automatic alerts and responses as your environment changes.",
            icon
        ],
        [
            "SmartState Analysis",
            "Get a handle on performance, capacity, and workloads through SmartState historical and trend analytics for different aspects of your cloud environment.",
            icon
        ],
        [
            "Container Management",
            "Take powerful container management systems like Kubernetes and OpenShift by Red Hat and integrate them with your VMware and RHEV environments.",
            icon
        ],
        [
            "Cloud-Bursting System Life Cycles",
            "Provision your systems through cloud and virtualization platforms like Red Hat Enterprise Virtualization, Amazon, and Microsoft Azure, set retirement dates, and scale your environment on your terms.",
            icon
        ],
        [
            "Proactive Capacity Planning",
            "Take your real-world environment and simulate what-if scenarios for proactive resource planning and continuous insights into consumption levels to allow detailed chargeback, quotas, and policy creation.",
            icon
        ]
    ];

    const corefeatures = [
        [
            "Cloud Providers",
            ["Microsoft Azure", "Red Hat Enterprise Linux Openstack Platform", "Amazon EC2", "Google Compute Engine"]
        ],
        [
            "Infrastructure Providers",
            [
                "Red Hat Enterprise Virtualization",
                "Red Hat OpenStack Platform Director",
                "Microsoft System Center Virtual Machine Manager",
                "VMware vCenter"
            ]
        ]
    ];

    const cfdetails =
        ["An open hybrid cloud is built on the best opensource technologies and integrates seamlessly with the most reliable public and private cloud providers. CloudForms is the engine to create a hybrid cloud because it can create the bridge between internal infrastructure providers like VMware and external cloud providers like Amazon and Azure."];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav overview={overview} features={features} corefeatures={corefeatures} cfdetails={cfdetails} />
            <Footer />
        </div>
    );
}

export default DetasadCloudManager;
